// extracted by mini-css-extract-plugin
export var card = "_7v-0";
export var expandedCard = "_7v-2";
export var paginated = "_7v-1";